import React from 'react'
import {Modal} from 'react-bootstrap'
import {OrderPriceBreakdown} from '../OrderPriceBreakdown/OrderPriceBreakdown'

const money = new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'})
const dateTime = new Intl.DateTimeFormat('es-MX', {dateStyle: 'medium', timeStyle: 'short'})
const formatDate = (value) => value ? dateTime.format(new Date(value.replace(' ', 'T'))) : 'No disponible'

function OrderDetail({detail, onHide, showPriceList = true}) {
  if (!detail) return null
  const creatorAvailable = Boolean(detail.generadoPorNombre)

  return <Modal show onHide={onHide} dialogClassName='pedido-modal' centered>
    <Modal.Header closeButton><Modal.Title>Detalle del pedido {detail.folio}</Modal.Title></Modal.Header>
    <Modal.Body><section className='pedido-detail-view'>

    <div className={`pedido-general-grid pedido-summary-grid${showPriceList ? '' : ' pedido-summary-grid-five'}`}>
      <div><span>Folio</span><strong>{detail.folio}</strong></div>
      <div><span>Fecha</span><strong>{formatDate(detail.fecha)}</strong></div>
      <div><span>Generado por</span><strong>{creatorAvailable ? detail.generadoPorNombre : 'Información no disponible'}</strong>{creatorAvailable && <small>{detail.generadoPorTipo}</small>}</div>
      <div><span>Vendedor asignado</span><strong>{detail.vendedorAsignadoNombre || 'Información no disponible'}</strong></div>
      {showPriceList && <div><span>Lista aplicada</span><strong className='pedido-list-name'>{detail.listaPrecioNombre || 'No disponible'}</strong></div>}
      <div className='pedido-summary-total'><span>Total</span><strong>{money.format(detail.total)}</strong></div>
    </div>

    <div className='pedido-comments'><span>Comentarios generales</span><p>{detail.comentariosGenerales || 'Sin comentarios.'}</p></div>

    <div className='table-responsive'>
      <table className='table align-middle pedido-detail-table'>
        <thead><tr><th>Código / producto</th><th>Unidad</th><th>Mínimo</th><th>Cantidad</th><th>Pzas. caja</th><th>Cajas</th><th>Precio</th><th>Subtotal</th><th>Comentarios</th></tr></thead>
        <tbody>{detail.productos.map((product) => <tr key={product.id}>
          <td><strong>{product.codigo}</strong><small>{product.descripcion}</small></td>
          <td>{product.unidadVenta} {product.unidad || ''}</td>
          <td>{product.pedidoMinimo}</td>
          <td>{product.cantidad}</td>
          <td>{product.piezasPorCaja ?? '—'}</td>
          <td>{product.cajas ?? '—'}</td>
          <td><OrderPriceBreakdown product={product} /></td>
          <td><strong>{money.format(product.subtotal)}</strong></td>
          <td>{product.comentarios || '—'}</td>
        </tr>)}</tbody>
        <tfoot><tr className='pedido-table-total-row'>
          <td colSpan='6' aria-hidden='true'></td>
          <td className='pedido-table-total-label'>Total del pedido</td>
          <td className='pedido-table-total'><strong>{money.format(detail.total)}</strong></td>
          <td aria-hidden='true'></td>
        </tr></tfoot>
      </table>
    </div>
    </section></Modal.Body>
  </Modal>
}

export {OrderDetail}
